import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { apiRequest } from "../apiService/allapi";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SampleNextArrow(props) {
  const { className, onClick } = props;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} categories-home__arrow`}
    >
      <i className="ph ph-caret-right" />
    </button>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} categories-home__arrow`}
    >
      <i className="ph ph-caret-left" />
    </button>
  );
}

const CategoriesHomeSection = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 2500,
    swipeToSlide: true,

    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 6,
        },
      },

      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },

      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };
  const fetchCategories = async () => {
    try {
      const res = await apiRequest("/Category/category/list", "GET");

      const catData = res?.data?.data || [];

      setCategories(catData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);

  if (loading) {
    return (
      <section className="categories-home py-60">
        <div className="container">
          <div className="text-center">Loading...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="categories-home py-60">
      <div className="container">
        <div className="section-heading mb-4 d-flex justify-content-between align-items-center">
          <h4 className="fw-bold mb-0">Shop by Categories</h4>
          <Link to="/shop" style={{ fontSize: "18px" }}>
            View All →
          </Link>
        </div>

        <div className="categories-home__slider sildergap">
          <Slider {...settings} className="">
            {categories.map((category) => (
              <div key={category.id || category._id} className="slider-item bg-white">
                <Link
                  to={`/shop?category=${category.id || category._id}`}
                  className="category-card"
                >
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}${category.imagePath}`}
                    alt={category.name}
                  style={{borderRadius:"100%",width:"60%",border:"1px solid #a3a2a2",margin:"auto",}} />

                  <h6 className="text-center">{category.name}</h6>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default CategoriesHomeSection;
